<template>
  <div>
    <el-dialog
      class="modal"
      title="刪除輪詢"
      :visible.sync="delModal"
      width="375px"
    >
      <div>確認刪除 {{ currentData.channel_name }} ?</div>
      <el-input v-model="oneCode" placeholder="驗證碼"></el-input>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="delModal = false" class="btn">取消</div>
        <div @click="confirmDel" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="編輯通道接口"
      :visible.sync="editModal"
      width="80%"
    >
      <p class="text-danger">金額限額:設置0,表示不限制</p>
      <p class="text-danger">可用時段:未設置,表示不限制</p>
      <p class="text-danger">
        餘額限制:商戶餘額在餘額限制內,通道才可使用,未設置,表示不限制
      </p>
      <el-input
        type="text"
        v-model="currentData.channel_name"
        placeholder="通道名稱"
        style="width: 300px;margin-top:18px"
      >
      </el-input>
      <el-table
        stripe
        :data="editList"
        border
        style="width: 100%;margin-top:18px"
      >
        <el-table-column
          :key="1"
          header-align="center"
          align="center"
          prop="id"
          label="選擇"
        >
          <template slot-scope="scope">
            <div>
              <el-checkbox v-model="scope.row.check"></el-checkbox>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :key="2"
          header-align="center"
          align="center"
          prop="id"
          label="通道代碼"
        >
        </el-table-column>
        <el-table-column
          :key="3"
          header-align="center"
          align="center"
          prop="alias"
          label="通道名稱"
          width="200"
        >
        </el-table-column>
        <el-table-column
          :key="4"
          header-align="center"
          align="center"
          prop="id"
          label="金額下限"
          width="150"
        >
          <template slot-scope="scope">
            <div>
              <el-input
                type="number"
                v-model="scope.row.lower"
                placeholder="金額下限"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :key="5"
          header-align="center"
          align="center"
          prop="id"
          label="金額上限"
          width="150"
        >
          <template slot-scope="scope">
            <div>
              <el-input
                type="number"
                v-model="scope.row.upper"
                placeholder="金額上限"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :key="6"
          header-align="center"
          align="center"
          prop="id"
          label="權重(1-9)"
          width="150"
        >
          <template slot-scope="scope">
            <div>
              <el-input
                type="number"
                v-model="scope.row.weight"
                placeholder="權重(1-9)"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          :key="7"
          header-align="center"
          align="center"
          prop="id"
          label="餘額限制"
        >
          <template slot-scope="scope">
            <div>
              <el-input
                type="number"
                v-model="scope.row.enable.balance_limit"
                placeholder="餘額限制"
                onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                oninput="if(value.length>6)value=value.slice(0,9)"
                onchange="value=value.replace(/^(0+)|[^\d]+/g,'')"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :key="8"
          header-align="center"
          align="center"
          prop="id"
          label="可用時段"
        >
          <el-table-column
            header-align="center"
            align="center"
            prop="id"
            label="開始"
            width="150"
          >
            <template slot-scope="scope">
              <div>
                <el-time-picker
                  style="width:90%"
                  placeholder="開始"
                  format="HH:mm"
                  value-format="HH:mm"
                  v-model="scope.row.enable.start"
                >
                </el-time-picker>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="id"
            label="結束"
            width="150"
          >
            <template slot-scope="scope">
              <div>
                <el-time-picker
                  style="width:90%"
                  placeholder="結束"
                  format="HH:mm"
                  value-format="HH:mm"
                  v-model="scope.row.enable.end"
                >
                </el-time-picker>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editModal = false" class="btn">取消</div>
        <div @click="confirmEdit" class="btn">確認</div>
      </div>
    </el-dialog>
    <p class="text-danger">
      請勿大量建立無意義通道，經查實一律封號處理。
    </p>
    <el-form
      :inline="true"
      :model="searchData"
      class="demo-form-inline"
      style="margin-top:15px"
      v-if="
        $store.state.userStatus != 'customer' &&
          $store.state.userStatus != 'customerSub'
      "
    >
      <el-form-item label="商戶號">
        <el-input v-model="searchData.id" placeholder="商戶號"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            inSearch = true;
            saveData = false;
            getData();
          "
          >搜尋</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      stripe
      :data="dataList"
      border
      style="width: 100%;margin-top:18px"
    >
      <el-table-column
        :key="1"
        header-align="center"
        align="center"
        prop="id"
        label="渠道編號"
      >
      </el-table-column>
      <el-table-column
        v-if="
          $store.state.userStatus != 'customer' &&
            $store.state.userStatus != 'customerSub'
        "
        :key="2"
        header-align="center"
        align="center"
        prop="customer_id"
        label="商戶號"
      >
      </el-table-column>
      <el-table-column
        :key="3"
        header-align="center"
        align="center"
        prop="type_alias"
        label="用戶名稱"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            {{ scope.row.user.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :key="4"
        header-align="center"
        align="center"
        prop="channel_name"
        label="通道名稱"
      >
      </el-table-column>
      <el-table-column
        :key="7"
        header-align="center"
        align="center"
        prop="type_alias"
        label="啟用狀態"
      >
        <template slot-scope="scope">
          <div>
            <el-switch
              @change="
                changeSwitch(
                  scope.row,
                  'status',
                  '啟用狀態',
                  `/back/collection_method/customer_models/${scope.row.id}`
                )
              "
              :value="scope.row.status == 1"
              active-color="#13ce66"
              inactive-color="#ff4949"
              v-if="$permission('collectionMethod.customer_c_m.update')"
            >
            </el-switch>
            <p v-else>
              {{ scope.row.status == 1 ? "開啟" : "關閉" }}
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :key="9"
        header-align="center"
        align="center"
        prop="type_alias"
        label="多次匹配"
        v-if="
          $store.state.userStatus != 'customer' &&
            $store.state.userStatus != 'customerSub'
        "
      >
        <template slot-scope="scope">
          <div>
            <el-switch
              @change="
                changeSwitch(
                  scope.row,
                  'mode',
                  '多次匹配',
                  `/back/collection_method/customer_models/${scope.row.id}`
                )
              "
              :value="scope.row.mode == 1"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :key="8"
        header-align="center"
        align="center"
        prop="type_alias"
        label="操作"
        width="200"
        v-if="
          $store.state.userStatus != 'customer' &&
            $store.state.userStatus != 'customerSub'
        "
      >
        <template slot-scope="scope">
          <div>
            <el-button
              size="mini"
              v-if="$permission('collectionMethod.customer_c_m.methods')"
              @click="editData(scope.row)"
              >編輯</el-button
            >
            <el-button
              v-if="$permission('collectionMethod.customer_c_m.destory')"
              size="mini"
              @click="delData(scope.row)"
              >刪除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        :current-page.sync="page"
        layout="prev, pager, next"
        :page-count="pagination.total_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      inSearch: true,
      saveData: false,
      searchData: {},
      dataList: [],
      pagination: {},
      editModal: false,
      currentData: {},
      editList: [],
      delModal: false,
      oneCode: ""
    };
  },
  watch: {
    page() {
      if (this.inSearch) {
        this.inSearch = false;
        return;
      }
      this.getData();
    }
  },
  methods: {
    confirmDel() {
      this.$http
        .delete(
          `/back/collection_method/customer_models/${this.currentData.id}`,
          {
            oneCode: this.oneCode
          }
        )
        .then(res => {
          if (res.data.code == 0) {
            this.delModal = false;
            this.$message.success("成功");
            this.getData();
          }
        });
    },
    delData(data) {
      this.oneCode = "";
      this.currentData = JSON.parse(JSON.stringify(data));
      this.delModal = true;
    },
    confirmEdit() {
      let sendData = this.editList.filter(e => {
        return e.check;
      });
      this.$http
        .put(`/back/collection_method/customer_models/${this.currentData.id}`, {
          channels: sendData,
          channel_name: this.currentData.channel_name
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.getData();
            this.editModal = false;
          }
        });
    },
    editData(data) {
      this.currentData = JSON.parse(JSON.stringify(data));
      this.$http
        .get(
          `/back/collection_method/customer_models/methods/${data.customer_id}`
        )
        .then(res => {
          if (res.data.code == 0) {
            let editList = res.data.data;
            editList.forEach(edit => {
              edit.check = false;
              edit.weight = "";
              edit.upper = "";
              edit.lower = "";
              edit.enable = {};
              if (data.channels) {
                data.channels.forEach(current => {
                  if (edit.id == current.id) {
                    edit.enable = current.enable;
                    edit.check = true;
                    edit.weight = current.weight;
                    edit.upper = current.upper || 0;
                    edit.lower = current.lower || 0;
                  }
                });
              }
            });
            this.editList = editList;
            this.currentData = JSON.parse(JSON.stringify(data));
            this.editModal = true;
          }
        });
    },
    changeSwitch(data, assign, title, api) {
      this.$alert(
        `確定${data[assign] == 1 ? "關閉" : "開啟"}${title}?`,
        title,
        {
          showCancelButton: true,
          confirmButtonText: "確定",
          cancelButtonText: "取消",
          beforeClose: (method, instance, done) => {
            let sendData = { id: data.id };
            sendData[assign] = data[assign] == 1 ? 0 : 1;
            if (method == "confirm") {
              this.$http.put(`${api}`, sendData).then(res => {
                if (res.data.code == 0) {
                  this.$message.success("成功");
                  this.getData();
                  done();
                } else {
                  done();
                }
              });
            } else {
              done();
            }
          }
        }
      );
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      searchData.page = this.page;
      this.$http
        .get(`/back/collection_method/customer_models`, { params: searchData })
        .then(res => {
          if (res.data.code == 0) {
            this.saveData = JSON.parse(JSON.stringify(searchData));
            this.inSearch = false;
            this.dataList = res.data.data;
            this.pagination = res.data.paginate;
          }
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>
